import React, { FunctionComponent, useState, useRef, useEffect } from "react";
import styles from "./DeleteSelectedModal.module.css";
import Modal from "react-modal";
import { connect, useDispatch } from "react-redux";
import Loading from "../../Loading/Loading";
import { showSnackbarAction } from "../../../Redux/actions";
import { db, firestore, functions, storage } from "../../../Firebase";
import Firebase from "firebase/app";
import { deleteRecords } from "../../../Services/contacts";
import axios from "axios";
import axiosHandler from "../../../Services/axiosHandler";
import { url } from "../../../Values/constants";
import { themeColors } from "../../theme";
import { motion, AnimatePresence } from "framer-motion";
import Backdrop from "../../Backdrop/Backdrop";
import { deleteNews, deleteNewsMongo } from "../../../Services/organizations";
import PopUpBox from "../../../Screens/AuditLogs/PopUpBox";
const nodemailer = require('nodemailer');


type props = {
  open: boolean;
  close: () => void;
  data: any;
  clearSelectedRowsData?: () => void;
  setOwner?: any;
  theme: any;
  tableType?: any;
  newsData?: any;
  user: any;
  organizationId: any;
  history?: any;
  authToken: any;
  panel?:any;
  selectedRows?: any[];
  organizationData?:any;
};

const dropIn = {
  hidden: {
    y: "-100vh",
    opacity: 1,
  },
  visible: {
    y: "0",
    opacity: 1,
    transition: {
      duration: 1,
      type: "spring",
      damping: 25,
      stiffness: 500,
    },
  },
};

const DeleteSelectedModal: FunctionComponent<props> = ({
  open,
  close,
  clearSelectedRowsData,
  setOwner,
  data,
  theme,
  newsData,
  tableType,
  user,
  organizationId,
  history,
  authToken,
  panel,
  selectedRows,
  organizationData
}) => {
  const [load, setLoad] = useState(false);
  const [popUpBox, setPopUpBox] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const dispatcher = useDispatch();
  useEffect(() => {
    if (isOtpVerified === true) {
      DeleteData();
    }
  }, [isOtpVerified]);

  const DeleteData = async () => {
    const newId: string[] = [];
    data.forEach((element: any) => {
      newId.push(element.contactId);
    });

    if (newId.length > 500) {
      dispatcher(showSnackbarAction("Maximum 500 records allowed", "error"));
      return;
    }

    setLoad(true);
    try {
      // axios.defaults.headers.common["x-access-token"] = authToken;
      const deleteLeads = await axiosHandler.post(url + "/leads/deleteMultipleLeads", {
        leadIds: newId,
        userAuthorizationId: user.uid,
      });

      SaveData();
      setTimeout(() => {
        close();
        setLoad(false);
        dispatcher(showSnackbarAction("Record Deleted", "success"));
        clearSelectedRowsData && clearSelectedRowsData();
        window.location.reload();
      }, 2500);
    } catch (err: any) {
      console.log(err);
      setTimeout(() => {
        close();
        setLoad(false);
        dispatcher(
          showSnackbarAction(err.response.data.message || "Failed", "error")
        );
      }, 2500);
    }
  };


  const deleteselectedRecord = async () => {
    if (tableType === "NEWS") {
      const myArrayFiltered = newsData.filter((el: any) => {
        return data.some((f: any) => {
          return f.name !== el.name;
        });
      })
      deleteNewsMongo(
        organizationId,
        myArrayFiltered,
        dispatcher,
      );
      setOwner(true);
      close();
    }
    else {
        // try {
          if (!organizationData.otp_verification_before_export) {
            DeleteData();
          } else {
            SendOTP();
            setPopUpBox(true)
          }
            // axios.defaults.headers.common['x-access-token'] = authToken
            // const deleteLeads = await axios.post(url + "/leads/deleteMultipleLeads", {leadIds:newId,userAuthorizationId:user.uid});

            //   SaveData()
            // setTimeout(() => {
            //   close();
            //   setLoad(false);
            //   dispatcher(showSnackbarAction("Record Delted", "success"));
            //   clearSelectedRowsData && clearSelectedRowsData();
            //   window.location.reload();
            // }, 2500);
            

        // }
        // catch (err:any) {
        //   console.log(err);
        //   setTimeout(() => {
        //     close();
        //     setLoad(false);
        //     dispatcher(showSnackbarAction(err.response.data.message ||"Failed", "error"));
        //   }, 2500);
        // }
    }
  };
  const customStyles = {
    content: {
      backgroundColor: theme ? themeColors.dropdownBackgroundColor : themeColors.dropdownBackgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark
    },
  };
  const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  const SaveData = async () => {
    try {
      let res = await axiosHandler.post(url+'/auditLogs/createExportLogs', {
      uid:user.uid?user.uid:"",
      user_email:user.user_email?user.user_email:"",
      user_first_name:user.user_first_name?user.user_first_name:"",
      user_last_name:user.user_last_name?user.user_last_name:"",
      total_count:selectedRows?.length?selectedRows?.length:"",
      type:panel?panel:"",
      organization_id:user.organization_id?user.organization_id:"",
      operation_type:"Delete",
      description:`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted ${selectedRows?.length?selectedRows?.length:""} records from ${panel?panel:""} panel.`
      })
      console.log("Delete Log Saved Successfully");
    } catch (error) {
      console.log(error,"Delete Log Couldn't Be Saved");
    }
}

const SendOTP = async () => {
  try {
    let res = await axiosHandler.post(url+'/otpVerification/sendOtpNew', {
      // uid:user.uid?user.uid:"",
      user_email:user.user_email?user.user_email:"",
      user_first_name:user.user_first_name?user.user_first_name:"",
      user_last_name:user.user_last_name?user.user_last_name:"",
      otp_mail:organizationData.otp_verification_mail ? organizationData.otp_verification_mail : "",
      data_count:selectedRows?.length?selectedRows?.length:"",
      type:panel?panel:"",
      operationType:"delete"

    })
    dispatcher(
      showSnackbarAction(
        res.data.message,
        'success'
      )
    );
  } catch (error) {
    dispatcher(
      showSnackbarAction(
        "OTP Not Sent ! Please Try Again",
        'error'
      )
    );
  }
};

  return (
    <>
      {load && <Loading />}
      {/* <Modal
        isOpen={open}
        className={styles.parent}
        overlayClassName={styles.overlay}
        onRequestClose={close}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        style={customStyles}
      >
        {load && <Loading />} */}
      {/* <div className={styles.headingContainer}>
          <h6 className={styles.heading}>Delete Selected Records</h6>
        </div> */}
      {/* <h6 
            className={styles.heading}
            >Delete Selected Records</h6>
        <div className={styles.container}> */}
      {/* <div className={styles.subheading}>
            <p className={styles.optionHeading}>Selected Options</p>
          </div> */}
      {/* <ol>
            {data.map((dat: any) => (
              <li>{dat.customer_name}</li>
            ))}
          </ol> */}
      {/* <ul className="list-group">
              <li className="list-group-item">An item</li>
              <li className="list-group-item">A second item</li>
              <li className="list-group-item">A third item</li>
              <li className="list-group-item">A fourth item</li>
              <li className="list-group-item">And a fifth one</li>
          </ul> */}
      {/* </div> */}

      {/* <div className={styles.buttonView}>
          <button className={styles.cancelButton} onClick={close}>
            Cancel
          </button> 
           <button className={styles.saveButton} onClick={deleteselectedRecord}>
            Save
          </button>
        </div>
      </Modal> */}
      <Backdrop>
        <motion.div
          key="modal"
          className="card p-4 shadow rounded"
          style={{
            position: "absolute", maxHeight: "320px",maxWidth: "320px",
            ...containerStyles
          }}
          variants={dropIn}
          initial="hidden"
          animate="visible"
          exit="exit"
        >
          {/* <div className={styles.headingContainer}>
          <h6 className={styles.heading}>Delete Selected Records</h6>
        </div> */}
          <h6
            // className={styles.heading}
          >Are you sure you want to delete the selected records?</h6>
          <div className={styles.container}>
            {/* <div className={styles.subheading}>
            <p className={styles.optionHeading}>Selected Options</p>
          </div> */}
            <ol>
              {data.map((dat: any) => (
                <li>{dat.customer_name || dat.name}</li>
              ))}
            </ol>
            {/* <ul className="list-group">
              <li className="list-group-item">An item</li>
              <li className="list-group-item">A second item</li>
              <li className="list-group-item">A third item</li>
              <li className="list-group-item">A fourth item</li>
              <li className="list-group-item">And a fifth one</li>
          </ul> */}
          </div>

          <div className={styles.buttonView}>
            <button className={styles.cancelButton} onClick={close}>
              Cancel
            </button>
            <button className={styles.saveButton} onClick={deleteselectedRecord}>
              Delete
            </button>
          </div>
        </motion.div>
      </Backdrop>
      {popUpBox && (
              <PopUpBox
              open={popUpBox}
              close={() => setPopUpBox(false)}
              setIsOtpVerified={setIsOtpVerified}
              setAuditLog={setPopUpBox}
              // onExport={exportFile}
              selectedRows={selectedRows}
              panel = "contacts"
              operationType='delete'
              />)}
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    theme: state.theme.isLightMode,
    organizationId: state.organization.id,
    authToken:state.user.authToken,
    organizationData: state.organization.organizationData,
  };
};
export default connect(mapStateToProps)(DeleteSelectedModal);